// extracted by mini-css-extract-plugin
export var image = "_hh-1";
export var imageContainer = "_hh-0";